import React from "react";
import Link from "next/link";

import { useStrainPageContext } from "@/context/StrainPageContext";
import { useEventTracker } from "@/hooks/useEventTracker";

import StarRating from "@/components/botanic/StarRating";

interface ReviewCTAProps {
  showRedesign?: boolean;
  starLink?: string;
  strainDetailsEventTracking?: () => void;
}

const ReviewCTA: React.FC<ReviewCTAProps> = ({
  showRedesign = false,
  starLink = "#strain-reviews-section",
  strainDetailsEventTracking,
}) => {
  const {
    strain: { reviewCount = 0, averageRating = 0, slug },
  } = useStrainPageContext();
  const { publishEvent } = useEventTracker();

  return reviewCount > 0 ? (
    <StarRating
      className="text-sm"
      starWidth={showRedesign ? 18 : 16}
      rating={Math.round(averageRating * 10) / 10}
      ratingCount={reviewCount}
      showRedesign={showRedesign}
      starLink={starLink}
      starLinkTracking={() => {
        if (strainDetailsEventTracking) {
          strainDetailsEventTracking();
        }
        publishEvent({
          action: "Click",
          category: "Link",
          label: "Reviews",
        });
      }}
    />
  ) : slug ? (
    <Link
      prefetch={false}
      href={`/strains/${slug}/reviews/write-review`}
      onClick={() => {
        publishEvent({
          action: "Click",
          category: "Reviews Link",
          label: "Write a Review - Empty State",
        });
      }}
      className="text-green underline"
    >
      Be the first to review!
    </Link>
  ) : (
    <></>
  );
};

export default ReviewCTA;
